import { LinearGradient } from 'expo-linear-gradient'
import { withUnistyles } from 'react-native-unistyles'

const UniLinearGradient = withUnistyles(LinearGradient)

export default UniLinearGradient
